export enum IconSizes {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}
export interface IIconProps {
  size?: IconSizes;
  color?: string;
  role?: string;
  focusable?: boolean;
  UNSAFE_className?: string;
}

export enum IconWidth {
  sm = 16,
  md = 24,
  lg = 32,
}

export enum IconHeight {
  sm = 16,
  md = 24,
  lg = 32,
}
